export const convertThousandsSeparatorToRegExp = (thousandsSeparator: string): RegExp | null => {
	// case for parameter 'nothing'
	if (thousandsSeparator.length === 0) {
		return null;
	}
	// case for parameter 'space'
	if (/\s/.test(thousandsSeparator)) {
		return /\s/g;
	}
	switch (thousandsSeparator) {
		case '.':
			return /\./g;
		default:
			return new RegExp(thousandsSeparator, 'g');
	}
};
